// src/components/Common/PromotionExpiryWarning.jsx
import React, { useState, useEffect } from "react";
import { FiAlertTriangle, FiX, FiClock } from "react-icons/fi";
import "../../styles/promotion-expiry.css";

const PromotionExpiryWarning = ({ items, onDismiss }) => {
  const [visible, setVisible] = useState(false);
  const [expiringItems, setExpiringItems] = useState([]);

  useEffect(() => {
    // Check for promotions that will expire soon (within 24 hours)
    const now = new Date();
    const twentyFourHours = 24 * 60 * 60 * 1000;

    const expiring = items.filter((item) => {
      if (!item.Promotion || !item.Promotion.EndDate) return false;

      const endDate = new Date(item.Promotion.EndDate);
      const timeUntilExpiry = endDate - now;

      // Promotion is expiring within 24 hours and hasn't expired yet
      return timeUntilExpiry > 0 && timeUntilExpiry <= twentyFourHours;
    });

    if (expiring.length > 0) {
      setExpiringItems(expiring);
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [items]);

  if (!visible || expiringItems.length === 0) return null;

  const handleDismiss = () => {
    setVisible(false);
    if (onDismiss) onDismiss();
  };

  const formatTimeUntilExpiry = (endDate) => {
    const now = new Date();
    const diff = new Date(endDate) - now;

    if (diff <= 0) return "Expired";

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

    if (hours > 0) {
      return `${hours}h ${minutes}m`;
    }
    return `${minutes}m`;
  };

  return (
    <div className="promotion-expiry-warning">
      <div className="promotion-expiry-content">
        <div className="promotion-expiry-icon">
          <FiAlertTriangle />
        </div>
        <div className="promotion-expiry-text">
          <h4>⚠️ Promotions Expiring Soon!</h4>
          <p>
            These promotions will expire soon. Complete your purchase now to
            save!
          </p>
          <div className="promotion-expiry-items">
            {expiringItems.map((item, index) => (
              <div key={index} className="promotion-expiry-item">
                <span className="item-name">{item.Name || item.name}</span>
                <span className="item-code">{item.Promotion.Code}</span>
                <span className="item-timer">
                  <FiClock />
                  {formatTimeUntilExpiry(item.Promotion.EndDate)}
                </span>
              </div>
            ))}
          </div>
        </div>
        <button className="promotion-expiry-close" onClick={handleDismiss}>
          <FiX />
        </button>
      </div>
    </div>
  );
};

export default PromotionExpiryWarning;
